(() => {
  if (window.pickyGuidanceAnalyticsLoaded) return;
  window.pickyGuidanceAnalyticsLoaded = true;
  const script = document.querySelector('script[data-picky-analytics]');
  if (!script) return;
  const destination = script.dataset.measurementId;
  const version = '2026-11-01';
  const debug = new URLSearchParams(location.search).get('picky_analytics_debug') === '1';
  const isQa = () => debug || new URLSearchParams(location.search).has('preview_theme_id') || !!document.querySelector('#PBarNextFrame');
  const guideId = {
    '/pages/beginner-paddles': 'beginner',
    '/pages/player-level': 'buying',
    '/blogs/news/14mm-vs-16mm-pickleball-paddles': 'thickness'
  }[location.pathname.replace(/\/$/, '')];
  let guideViewed = false;
  let attempts = 0;
  const runs = new WeakMap();
  const completedRuns = new WeakMap();
  const allowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch {
      return false;
    }
  };
  const diagnostic = (state, name, params) => {
    if (!debug) return;
    let output = document.getElementById('picky-analytics-debug');
    if (!output) {
      output = document.createElement('output');
      output.id = 'picky-analytics-debug';
      output.hidden = true;
      document.body.append(output);
    }
    const history = JSON.parse(output.textContent || '[]');
    history.push({state, name, params});
    output.textContent = JSON.stringify(history.slice(-50));
  };
  const send = (name, params = {}) => {
    if (!allowed()) {
      diagnostic('blocked_by_consent', name, params);
      return false;
    }
    const tag = [...document.scripts].some(item => item.src.startsWith('https://www.googletagmanager.com/gtag/js'));
    if (!tag || !Array.isArray(window.dataLayer)) {
      diagnostic('existing_tag_unavailable', name, params);
      return false;
    }
    const payload = {send_to: destination, guide_version: version, qa_mode: isQa() ? 'yes' : 'no', ...params};
    if (debug) {
      payload.debug_mode = true;
      payload.event_callback = () => diagnostic('processed_by_google_tag', name, params);
    }
    if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    else {
      const enqueue = function () { window.dataLayer.push(arguments); };
      enqueue('event', name, payload);
    }
    diagnostic('queued_to_existing_google_tag', name, payload);
    return true;
  };
  const viewGuide = () => {
    if (guideId && !guideViewed && send('picky_guide_view', {guide_id: guideId})) guideViewed = true;
  };
  const initialisePrivacy = () => {
    if (window.Shopify?.customerPrivacy) {
      viewGuide();
      return;
    }
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        if (!error) viewGuide();
      });
    } else if (++attempts < 20) setTimeout(initialisePrivacy, 500);
  };
  const runId = () => window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const productFields = anchor => {
    const url = new URL(anchor.href, location.origin);
    return {item_handle: url.pathname.split('/products/')[1]?.split('/')[0] || '', item_variant: url.searchParams.get('variant') || 'not_selected'};
  };
  document.addEventListener('click', event => {
    const target = event.target.closest?.('button, a');
    if (!target) return;
    const finder = target.closest('[data-refresh-finder]');
    if (finder && (target.matches('[data-finder-open]') || target.matches('[data-finder-retake]'))) {
      runs.set(finder, runId());
      completedRuns.delete(finder);
      send('picky_finder_start', {journey_id: runs.get(finder)});
    }
    if (finder && target.matches('[data-finder-compare]') && !target.disabled) {
      send('picky_finder_compare', {journey_id: runs.get(finder) || '', selection_count: finder.querySelectorAll('[data-compare-id]:checked').length});
    }
    if (finder && target.closest('[data-finder-cards]') && target.matches('a[href*="/products/"]')) {
      send('picky_finder_product_click', {journey_id: runs.get(finder) || '', ...productFields(target)});
    }
    if (guideId && target.matches('[data-pg-choice]')) {
      send('picky_guide_choice', {guide_id: guideId, choice: target.dataset.pgChoice});
    }
    if (guideId && target.matches('a[href*="/products/"]') && !target.closest('header, footer, nav, .picky-related')) {
      send('picky_guide_product_click', {guide_id: guideId, ...productFields(target)});
    }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-finder-form]')) return;
    const finder = event.target.closest('[data-refresh-finder]');
    queueMicrotask(() => {
      const results = finder.querySelector('[data-finder-results]');
      const id = runs.get(finder);
      if (!id || results.hidden || completedRuns.get(finder) === id) return;
      completedRuns.set(finder, id);
      const data = new FormData(event.target);
      send('picky_finder_complete', {
        journey_id: id,
        play_style: data.get('style'),
        budget_band: data.get('budget'),
        result_count: finder.querySelectorAll('[data-finder-cards] .refresh-match').length
      });
    });
  });
  document.addEventListener('visitorConsentCollected', viewGuide);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialisePrivacy, {once: true});
  else initialisePrivacy();
})();
